'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

// Routes to preload for faster navigation. Only pages that exist in the MyCIO app: the legacy routes that used
// to be listed here (/target, /implementation, /tlh, /holdings, /trade-list) were removed in the extraction and
// 404'd on every page view.
const PRELOAD_ROUTES = [
  '/dashboard',
  '/sign-in',
  '/settings',
]

export function RoutePreloader() {
  const router = useRouter()

  useEffect(() => {
    // Preload critical routes after initial load
    const preloadTimer = setTimeout(() => {
      PRELOAD_ROUTES.forEach(route => {
        router.prefetch(route)
      })
    }, 1000) // Wait 1 second after initial load

    return () => clearTimeout(preloadTimer)
  }, [router])

  return null
}